import { AgentFinanceWebService } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: AgentFinanceWebService.Configuration
});

export default config;
